import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as AbHooks from "abreact/utils/AbHooks";
import { observer, Observer } from "mobx-react";
import * as React from "react";
import { AbDimensions } from "abweb/utils/geometry/AbDimensions";

/**
 * The properties for an AbAutoSizer.
 */

/**
 * A container that automatically sizes to the space provided by its parent.
 */
export const AbAutoSizer = observer(props => {
  const [dimensions, setDimensions] = React.useState(undefined);
  const childRef = AbHooks.useParentResizeObserver(setDimensions);

  // .ab-auto-sizer is used to match the width and height of the parent
  // .ab-auto-sizer-container has position: absolute to pull the contents out of the standard flow and allow it to
  // shrink/grow with impunity. This avoids buggy situations created when browsers do ridiculous size calculations.
  return /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-auto-sizer", props), {
    style: {
      ...props.style,
      width: props.width ?? props.style?.width,
      height: props.height ?? props.style?.height
    },
    ref: childRef
  }), AbDimensions.isSafeForRendering(dimensions) && /*#__PURE__*/React.createElement("div", {
    className: "ab-auto-sizer-container",
    style: {
      width: props.width ?? dimensions.width,
      height: props.height ?? dimensions.height
    }
  }, /*#__PURE__*/React.createElement(Observer, null, () => props.renderer(props.width ?? dimensions.width, props.height ?? dimensions.height))));
});
//# sourceMappingURL=AbAutoSizer.js.map
